const TableCell = ({ children, w }) => {
  return (
    <div style={{ width: `${w}%` }} className="break-words ">
      {children}
    </div>
  );
};

export default TableCell;
